import { peticionesReceiver } from "../../../../helpers/peticionesReceiver";
import { toast } from "react-toastify";
import Notification from "../../../../components/Notification/Notification";

export function getMonthsOrigin(idStateFund, annualBudget, idExpenseObject, setOptions) {
    if (annualBudget && idStateFund && idExpenseObject) {
        const API = peticionesReceiver();
        const params = {
            action: "getMonthsOrigin",
            idAnnualBudget: annualBudget.id,
            idStateFund,
            idExpenseObject
        };
        API.peticionEndPoint(params, "app/facades/budgets/budgetsF.php")
            .then((res) => {
                if (res.status === 200) {
                    setOptions(res.data.data);
                } else {
                    toast(
                        <Notification
                            type={"consultar_error"}
                            backMessage={res.data.message}
                            withIcon
                        />
                    );
                }
            })
            .catch((err) => {
                toast(<Notification type={"consultar_servidor_error"} withIcon />);
            });
    }
}


export function getMonthsDestination(idStateFund, annualBudget, idExpenseObject, setOptions) {
    if (annualBudget && idStateFund && idExpenseObject) {
        const API = peticionesReceiver();
        const params = {
            action: "getMonthsDestination",
            idAnnualBudget: annualBudget.id,
            idStateFund,
            idExpenseObject
        };
        API.peticionEndPoint(params, "app/facades/budgets/budgetsF.php")
            .then((res) => {
                if (res.status === 200) {
                    setOptions(res.data.data);
                } else {
                    toast(
                        <Notification
                            type={"consultar_error"}
                            backMessage={res.data.message}
                            withIcon
                        />
                    );
                }
            })
            .catch((err) => {
                toast(<Notification type={"consultar_servidor_error"} withIcon />);
            });
    }
}